import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";

export function useBlocks() {
  const t = useFormatMessage();

  return [
    [t(intlMessages.paragraph), "p"].join("="),
    [t(intlMessages.header2), "h2"].join("="),
    [t(intlMessages.header3), "h3"].join("="),
    [t(intlMessages.small), "small"].join("=")
  ].join("; ");
}

const intlMessages = defineMessages({
  paragraph: {
    id: "editor.blocks.paragraph",
    defaultMessage: "Paragraphe"
  },
  header2: {
    id: "editor.blocks.header2",
    defaultMessage: "Titre 2"
  },
  header3: {
    id: "editor.blocks.header3",
    defaultMessage: "Titre 3"
  },
  small: {
    id: "editor.blocks.small",
    defaultMessage: "Taille réduite"
  }
});
